import ProposalPageScreen from '../../components/Proposal/ProposalPageScreen'

function ProposalPage() {
	return <ProposalPageScreen />
}

export default ProposalPage
